import { mensagemCampoObrigatorio, mensagemMinimoXCaracteres } from '@core/util/mensagemUtil';
import * as yup from 'yup';

const AlterarSenhaSchema = yup
  .object()
  .shape({
    senhaAtual: yup
      .string()
      .min(4, mensagemMinimoXCaracteres(4))
      .nullable()
      .required(mensagemCampoObrigatorio('a Senha atual')),
    novaSenha: yup
      .string()
      .min(4, mensagemMinimoXCaracteres(4))
      .nullable()
      .required(mensagemCampoObrigatorio('a Nova senha')),
    confirmarNovaSenha: yup
      .string()
      .min(4, mensagemMinimoXCaracteres(4))
      .nullable()
      .required(mensagemCampoObrigatorio('a Nova senha de confirmação'))
      .test('test-confirmar-senha', 'As senhas informadas devem ser iguais', function validaSenha(confirmarNovaSenha) {
        return confirmarNovaSenha && this.parent.novaSenha && confirmarNovaSenha === this.parent.novaSenha;
      }),
  })
  .nullable();

export default AlterarSenhaSchema;
